module.exports = __webpack_public_path__ + "img/miniapp-preview-01.40b9b99c.jpg";